import { Box, Button, Checkbox, CircularProgress, Grid, InputLabel, Link, TextField, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { SectionHeaderNoImage } from '../../../components/molecules/SectionHeaderNoImage';

import iconoEditar from '../../../assets/icons/icono-editar.svg';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SectionHeader from '../../../components/molecules/SectionHeader';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { insertTipoGpsVersion } from '../../../services/administracion';
import { PopUpSuccess } from '../../../components/organisms/PopUpSuccess';
import Pool from '../../../authentication/../UserPool';
import { PopUpConfirmacionGenerico } from '../../../components/organisms/PopUpConfirmacionGenerico';
import { AlertaGenerica } from '../../../components/molecules/AlertaGenerica';


const useStyles = makeStyles({
    table: {
      width:"100%"
    },
    root: {
      backgroundColor: "#2f4554",
      margin: "px 0",
      textAlign:'center',
      color: "white",
      "&:hover": {
        backgroundColor: "rgb(0, 183, 196)"
      },
      "&:disabled": {
        backgroundColor: "gray"
      }
    }
  });

  const initialStatePoUps = ({
    showPopUpSuccess:false,
    showPopUpDelete:false,
    showPopUpConfirmEdit:false
  });

export const TiposGeocercasForm = ({data, id_area_operacion, isEditing, onHandleCloseForm, nombreMina, pathMina, formDataEdit, refForm}) => {
    const [estadoPopUps,setEstadoPopUps] = useState(initialStatePoUps);
    const [loadingVista, setLoadingVista] = useState(false);
    const [alert, setAlert] = useState({
        open: false,
        message: "",
        severity: "success",
      });
    const onHandleShowPopUpSuccess = (show) =>{
        setEstadoPopUps((prevState) => ({...prevState,showPopUpSuccess:show}))
      }
      const onHandleShowPopUpDelete = (show) =>{
        setEstadoPopUps((prevState) => ({...prevState,showPopUpDelete:show}))
      }

      const onHandleShowPopUpConfirmEdit = (show) =>{
          setEstadoPopUps((prevState) =>({...prevState,showPopUpConfirmEdit:show}))
          setAllFieldsTouched();
      }

      const setAllFieldsTouched = () => {
        Object.keys(formik.values).forEach(fieldName => {
          formik.setFieldTouched(fieldName, true);
        });
      };
      const onHandleRefFormClick = () =>{
        refForm.current?.scrollIntoView({ behavior: 'smooth' });
      }

    const initialStateForm = {
        id:0,
        id_area_operacion: id_area_operacion,
        nombre_mina: nombreMina,
        nombre:'',
        editing:false,
        solicitante:Pool.getCurrentUser().username,
        pathMina:pathMina
      }
      const validationSchema = Yup.object().shape({
        nombre:Yup.string()
          .test(
            "nombreTipoGeocerca",
            "El nombre es obligatorio",
            value => value !== '' && value 
          ),

      });
      
    const formik = useFormik({
    initialValues: initialStateForm,
    validationSchema:validationSchema,
    onSubmit: async (values) => {
        try {
        const {
          id,
          id_area_operacion,
          nombre_mina,
          nombre,
          solicitante,
          pathMina,
          editing
        } = values;
        await insertTipoGpsVersion(id, id_area_operacion, nombre, solicitante, editing, pathMina, nombre_mina);        
        } catch (error) {
            console.log(error)
        }
    },
    });

    const { t } = useTranslation();
    const classes = useStyles();

    const onHandleSetFormikValues = (formDataEdit) =>{
      const { id,nombre,editing } = formDataEdit;
      formik.setFieldValue("id",id ? id : initialStateForm.id);
      formik.setFieldValue("nombre", nombre ? nombre : initialStateForm.nombre)
      formik.setFieldValue("editing",editing ? editing : initialStateForm.editing);
      formik.setFieldValue("solicitante", Pool.getCurrentUser().username)
      formik.setFieldValue("id_tipo_operacion",2)
      setLoadingVista(false)
    }

      const handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        setAlert({ open: false, message: alert.message, severity: alert.severity });
      };

    useEffect(() => {
      setLoadingVista(true)
      formik.setValues({...formik.values})
      onHandleSetFormikValues(formDataEdit);
      setLoadingVista(false);
    }, [formDataEdit?.id])

    useEffect(() => {
      if(!loadingVista){
        onHandleRefFormClick();
      }
    }, [loadingVista])
    
    

      const handleErrorForm = () => {

        if (!formik.isValid) {
          let msg = "";
          const claves = Object.keys(formik.errors);
          for (const clave of claves) {
            const valor = "* " + formik.errors[clave] + "?";
            msg += valor;
          }
          setAlert({
            open: true,
            message: msg,
            severity: "warning",
          });
          return true;
        }else{
            return false
        }
      };

      if(formik.isSubmitting || loadingVista){
        return (
            <Grid container justifyContent="center" alignItems="center">
                <CircularProgress />
            </Grid>
        )
    }

  return (
    <div ref={refForm} >
        <Grid style={{padding:'48px', backgroundColor:'#f3f4f7', border:'3px solid rgb(0, 183, 196)'}} container>
            <Grid container style={{marginBottom:'30px'}}>
                {/* <SectionHeader icon={!isEditing ? <AddCircleOutlineIcon fontSize='large'/> : <iconoEditar fontSize='large'/>} title={!isEditing ? `${t('Agregar nueva definición de ciclo')}` : `Editar definición de ciclo`} /> */}
                {
                    isEditing ?
                    (
                        <SectionHeader icon={<img src={iconoEditar} style={{maxWidth:'32px'}}/>} title={`${t('editar_tipo_geocerca')}`} subtitle={t('actualizacion_de_la_informacion')}/>
                    ) :
                    (
                        <SectionHeader icon={<AddCircleOutlineIcon fontSize='large'/>} title={`${t('agregar_nuevo_tipo_geocerca')}`} />
                    )
                }
            </Grid>
            <Grid container spacing={5} style={{marginBottom:'20px'}}>
                <Grid item container xs={6}>
                    <Grid item xs={12} container spacing={1} wrap='nowrap' alignItems='center'>
                        <Grid item xs={3}>
                            <InputLabel >
                            <SectionHeaderNoImage title={t('minaSingular')}/>
                            </InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                id="margin-none"
                                name="nombre_mina"
                                type="text"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                style={{ marginTop: "15px" }}
                                fullWidth
                                variant='outlined'
                                hiddenLabel
                                size='small'
                                margin='none'
                                disabled
                                value={formik.values.nombre_mina}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                {/* SEGUNDA COLUMNA */}
                <Grid item container xs={6}>
                    <Grid item xs={12} container spacing={1} wrap='nowrap' alignItems='center'>
                            <Grid item xs={3}>
                                <InputLabel >
                                <SectionHeaderNoImage title={t('nombre')}/>
                                </InputLabel>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="margin-none"
                                    name="nombre"
                                    type="text"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ marginTop: "15px" }}
                                    fullWidth
                                    variant='outlined'
                                    hiddenLabel
                                    size='small'
                                    margin='none'
                                    onChange={(e) =>formik.setFieldValue("nombre",e.target.value.toString())}
                                    value={formik.values.nombre}
                                />
                            </Grid>
                        </Grid>
                </Grid>
                
            </Grid>

            {/* FOOTER */}
            <Grid container direction='row' wrap='nowrap' justifyContent='space-between' spacing={1} style={{maxHeight:'41px'}}>
                <Grid item xs={9} container wrap='nowrap' justifyContent='flex-start' alignItems='flex-start'>
                    <Box sx={{backgroundColor:'rgb(0, 183, 196)'}}>
                            <InfoOutlinedIcon  fontSize='large' sx={{color:'white',padding:'5px'}}/>
                    </Box>
                    <Box sx={{color:'#666666' ,padding:'10.5px 25px', backgroundColor:'#eaedf1'}}>{t('recuerdo_aprobacion')}</Box>
                </Grid>
                <Grid item xs={3}>
                    <Box>
                        <Button
                            fullWidth
                            type="button"
                            variant="contained"
                            className={classes.root}
                            style={{textAlign:'center', marginBottom:'15px'}}
                            onClick={() => onHandleShowPopUpConfirmEdit(true)}
                            >
                            {isEditing ? t("guardar_cambios"): t("agregarr")}
                        </Button>
                    </Box>
                    <Box sx={{display:'flex',justifyContent:'center'}}>
                    <Link 
                    style={{cursor:'pointer'}} 
                    onClick={()=>{
                        onHandleCloseForm()
                        }} 
                    underline='always' 
                    color='inherit'>{t('cancelar')}</Link>
                    </Box>
                </Grid>
            </Grid>
        </Grid>

        {/* PopUp confirmEdit */}
        <PopUpConfirmacionGenerico
            editing={isEditing}
            formik={formik}
            onHandleShowPopUp={onHandleShowPopUpConfirmEdit}
            show={estadoPopUps.showPopUpConfirmEdit}
            onHandleShowPopUpSuccess={onHandleShowPopUpSuccess}
            handleErrorForm={handleErrorForm}
            dataColumnas={{
                columna1:[{
                    label:t("mina"),
                    value:formik.values.nombre_mina
                }],
                columna2:[{
                    label:t("tipo_geocerca"),
                    value:formik.values.nombre
                }]
            }}
        />
        
        {/* PopUp Success */}
        <PopUpSuccess onHandleShowPopUp={onHandleShowPopUpSuccess} show={estadoPopUps.showPopUpSuccess} onHandleViewform={onHandleCloseForm} onHandleEditVicons={onHandleCloseForm} />


        {/* ALERTA DE VALIDACIONES */}
        <AlertaGenerica alert={alert} handleCloseAlert={handleCloseAlert} duration={5000} />
    </div>
  )
}
